<template>
	<v-container tag="section" aria-label="Benefits Section" class="container">
		<v-row class="d-flex align-center">
			<v-col
				cols="12"
				md="6"
				class="text-container text-center justify-center justify-md-start text-md-left"
				tag="section"
			>
				<v-card-subtitle
					:class="isMobile ? 'v-typography--title1' : 'v-typography--title2'"
					class="accent--text title-with-line pa-0 pl-1"
					tag="h2"
				>
					{{ $t(`$landing.$benefits.benefits_title`) }}
				</v-card-subtitle>

				<v-card-title
					:class="isMobile ? 'v-typography--title' : 'v-typography--title3'"
					class="pa-1 text-center justify-center text-md-left justify-md-start mt-2 mb-4"
					tag="h3"
				>
					<span v-html="formattedControlTitle"></span>
				</v-card-title>

				<v-card-subtitle
					:class="isMobile ? 'v-typography--body1' : 'v-typography--paragraph'"
					class="pa-1 mb-0 text-center justify-center text-md-left justify-md-start"
					tag="p"
				>
					{{ $t(`$landing.$benefits.text`) }}
				</v-card-subtitle>

				<v-list tag="ul" class="pl-0 bg_transparent">
					<v-list-item
						v-for="benefit in displayBenefits"
						:key="benefit.text"
						:class="isMobile ? 'v-typography--body1' : 'v-typography--paragraph'"
						class="pa-1 d-flex align-center no-min-height text-center justify-center text-md-left justify-md-start"
						tag="li"
					>
						<img
							src="@/assets/red_check.webp"
							class="check-img mr-2"
							alt="Check icon indicating a benefit"
							loading="lazy"
							height="17"
							width="17"
						/>
						{{ $t(benefit.text) }}
					</v-list-item>
				</v-list>
				<v-btn
					v-if="!useDetailBenefits"
					class="mt-4"
					x-large
					color="secondary"
					@click="goToBenefitsFeature"
					aria-label="Discover all Antrego benefits"
				>
					<span :class="isTablet ? 'v-typography--paragraph' : ''">
						{{ $t("discover_all_benefits") }}
					</span>
				</v-btn>
			</v-col>
			<v-col cols="12" md="6" class="d-flex justify-center align-center">
				<v-img
					src="https://fs.antrego.net/landing/benefits.webp"
					class="image-style"
					alt="Illustration showing the features and benefits of Antrego platform"
					contain
					max-height="450"
				/>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	props: { isMobile: Boolean, isTablet: Boolean, useDetailBenefits: Boolean },
	data() {
		return {
			benefits: [
				{ icon: "icon-check", text: "$landing.$benefits.business_process" },
				{ icon: "icon-check", text: "$landing.$benefits.risk_of_error" },
				{ icon: "icon-check", text: "$landing.$benefits.time_and_cost_savings" },
			],
			detailBenefits: [
				{ icon: "icon-check", text: "$landing.$benefits.$detailPage.benefit_1" },
				{ icon: "icon-check", text: "$landing.$benefits.$detailPage.benefit_2" },
				{ icon: "icon-check", text: "$landing.$benefits.$detailPage.benefit_3" },
				{ icon: "icon-check", text: "$landing.$benefits.$detailPage.benefit_4" },
				{ icon: "icon-check", text: "$landing.$benefits.$detailPage.benefit_5" },
				{ icon: "icon-check", text: "$landing.$benefits.$detailPage.benefit_6" },
			],
		};
	},
	computed: {
		displayBenefits() {
			return this.useDetailBenefits ? this.detailBenefits : this.benefits;
		},
		highlightedWord() {
			const wordMap = {
				en: "control",
				tr: "kontrol",
			};
			const lang = this.$i18n.locale;
			return wordMap[lang] || "control";
		},
		formattedControlTitle() {
			const originalText = this.$t(`$landing.$benefits.control_title`);
			const highlighted = this.highlightedWord;
			const regex = new RegExp(`(${highlighted})`, "i");
			return originalText.replace(regex, '<span style="color: #B71C1C;">$1</span>');
		},
	},
	methods: {
		goToBenefitsFeature() {
			this.$router.push({ name: "benefits_feature" });
		},
	},
};
</script>

<style scoped>
.image-style {
	max-width: 100%;
	width: 100%;
}

.title-with-line {
	position: relative;
	display: inline-block;
}

.title-with-line::after {
	content: "";
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 1px;
	background-color: currentColor;
	transform: scaleX(0.4);
	transform-origin: left;
	margin-left: 4px;
}

.check-img {
	width: 17px;
	height: 17px;
}

@media (min-width: 1904px) {
	.container {
		max-width: 1185px !important;
	}
}
@media (max-width: 960px) {
	.title-with-line::after {
		height: 0px;
	}
}
</style>
